import React, { Component } from 'react';
import './App.css';
import Navbar from './component/navbar/navbar';
import Footer from './component/footer/footer';
import Main from './component/main/main';
import { Provider } from 'react-redux';
import store from './store/store';

class App extends Component {

    render() {
        return(
            <Provider store={store}>
                <div className="App">
                    <Navbar/>
                    <div className="container-fluid">
                        <Main/>
                    </div>
                    <Footer/>
                </div>
            </Provider>
        )
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js